import React from 'react';
import ContentLayout from '../../../../components/ContentLayout';
import props from '../../../../lib/contentLayoutProps/learning-at-kingston/primary-school/layoutProps';

import image from './athletics@large.jpg';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="zh" pageKey="athletics">
    <h1>體育</h1>
    <p>
      京斯敦提供完善及具挑戰性的體育課程予學生，讓學生在體能、智力、情商及社交方面得以全面發展。我們鼓勵京斯敦的學生透過參與各種運動來保持長久的健康生活。本校的課程能讓學生透過與健康有關的體能活動、歷奇運動、各種遊戲、身體的律動及個人運動目標的追求增加學習的機會，讓他們達致平衡發展。
    </p>
    <p>
      在京斯敦，我們很高興能與本地的機構合作，每年舉辦Terry Fox
      Run活動，藉以推廣健康生活及提升師生及家長對癌症的關注。這個一年一度的大型學校活動亦會為本地醫院的腫瘤機構籌款。本校每年亦會舉辦運動會，讓所有學生參與不同的運動項目及集體遊戲。
    </p>
    <p>
      學校設有三個操場及一個禮堂，學生能享用這些寬敞的活動空間來學習及進行體育活動。我們亦設有一系列高水平及現代化的體育器材供學生使用。學生能在小息時於大操場使用這些器材，探索不同的體育活動。
    </p>
    <img src={image} alt="Athletics" />
  </ContentLayout>
);
